export default __webpack_public_path__ + "a751609dfe67f46573863b80eedeec15.svg";